module.exports = __webpack_public_path__ + "img/roles_5.4280a4f6.png";